GroupRankingService = ($http ,$q )  ->

  listRanking:(dParam) ->
    defer = $q.defer()
    url = "/api/groups/ranking_events/me.json"
    $http.get(url, params: dParam ).then (resp) ->
      defer.resolve resp.data
    defer.promise

  checkJoinGroup:(id) ->
    defer = $q.defer()
    url = "/api/users/join_group.json?group_id=#{id}"
    $http.get(url).then (resp) ->
      defer.resolve resp.data
    defer.promise

  createEvent:(event , dataCover) ->
    defer = $q.defer()
    promise =
      urlCover: groupUploadDataService.uploadS3(dataCover.coverFile ,dataCover.url , dataCover.fields )

    $q.all(promise).then (data) ->
      event.cover_path = data.urlCover
      $http.post('/api/group_events.json', event)
        .then (data) ->
          defer.resolve 'success'
        , (data) ->
          defer.reject data
    defer.promise

GroupRankingService.$inject = [
  '$http'
  '$q'
]

module.exports = GroupRankingService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-ranking/group-ranking-service.coffee